import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControl from '../FormControl';
import FormControlLabel from '../FormControlLabel';
import FormHelperText from '../FormHelperText';
import ModulEnum from 'src/enums/ModulEnum';
import { isVisible } from 'src/utils/formAuthHelper';

export interface ICheckboxProps extends CheckboxProps {
  label?: string;
  error?: boolean;
  helperText?: string;
  authCode?: string;
  modul?: ModulEnum;
}

const Checkbox = (props: ICheckboxProps): JSX.Element => {
  const { authCode, modul} = props;
  return ( 
    isVisible(authCode, modul) && (
   <FormControl error={props.error} fullWidth size="small" sx={props.sx} disabled={props.disabled}>
    <FormControlLabel disabled={props.disabled}
      control={
        <MuiCheckbox
          {...props}
          color="primary"
          size="small"
        ></MuiCheckbox>
      }
      label={props.label || ""}
      labelPlacement="end"
    ></FormControlLabel>
    <FormHelperText error={props.error}>{props.helperText}</FormHelperText>
  </FormControl>
  ))
};

export default Checkbox;
